import { IOption } from "./components/SelectInput";

export type TValidContentTypes = number | string | Date | boolean;
export type TColumnTitle = string;

export interface IWithTableProps {
  tableTitle?: object;
  createButton?: object;
}
export interface IWithActionButtonProps {
  editButton?: object;
  deleteButton?: object;
  confirmButton?: object;
  cancelButton?: object;
}

export interface IMaterialDataTableItem<T extends TValidContentTypes> {
  content: T;
  options?: string[];
  props?: object;
}

export type TDynamicDataTableItemDictionary<C extends TValidContentTypes[]> = {
  [I in keyof C]: C[I] extends TValidContentTypes
    ? IMaterialDataTableItem<C[I]>
    : any;
};

export interface IMaterialDataTableRow<C extends TValidContentTypes[]> {
  id: string;
  cells: TDynamicDataTableItemDictionary<C>;
  props?: Object & IWithActionButtonProps;
}

export interface IMaterialDataTableEditRow<T extends TValidContentTypes> {
  id: string;
  cells: IMaterialDataTableItem<T>[];
  props?: IWithActionButtonProps;
}

export interface IMaterialDataTablePagination {
  pageSizes: number[];
  totalCount: number;
  currentPage: number;
  currentPageSize: number;
  onChangePage: (newPage: number) => void;
  onChangePageSize: (newPageSize: number) => void;
}

export interface IMaterialDataTableProps<C extends TValidContentTypes[]> {
  title: string;
  rows: IMaterialDataTableRow<C>[];
  columnTitles: TColumnTitle[];
  pagination?: IMaterialDataTablePagination;
  className?: string;
  readOnly?: boolean;
  tableProps?: IWithTableProps;
  onRowCreate?: (row: IMaterialDataTableEditRow<TValidContentTypes>) => void;
  onRowUpdate?: (row: IMaterialDataTableEditRow<TValidContentTypes>) => void;
  onRowDelete?: (row: IMaterialDataTableEditRow<TValidContentTypes>) => void;
}


export let defaultGrey = "#8c8c8c";
export let disabledGrey = "#d9d9d9";